import { Link } from "react-router-dom";

export const Logo = ({ className = "h-9 sm:h-10", testid = "brand-logo" }) => (
  <Link to="/" data-testid={testid} className="flex flex-col items-start leading-none shrink-0">
    <img src="/img-health-logo-trim.png" alt="IMG Health logo" className={`${className} w-auto`} />
  </Link>
);

